import { isDesktopSize } from '$func/environmentInfo'

export function useIsDesktopSize() {
  return isDesktopSize()
}
